import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as firebase from 'firebase';
import 'firebase/auth';
import 'firebase/firestore';
import { ToastService } from '../typescripts/pro/alerts';
import {MDBSpinningPreloader} from '../typescripts/pro/index';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  user;
  userId;
  email;
  password;
  constructor(
    private router: Router,
    private toast: ToastService,
    private mdbSpinningPreloader: MDBSpinningPreloader
  ) {
    var that = this;

    that.userId = localStorage.getItem('userId');
    if(that.userId){
      console.log('localStorage User', that.userId)
      that.router.navigate(['main']);
    }
    firebase.auth().onAuthStateChanged(function(user) {

      if (user) {

      } else {
        localStorage.removeItem('userId');
        that.router.navigate(['']);
      }
    });
  }

  ngOnInit() {
  }

  doLogin(){
    //var db = firebase.firestore();
    var that = this;
    that.mdbSpinningPreloader.start()
    firebase.auth().signInWithEmailAndPassword(that.email, that.password)
    .then((user)=>{
      console.log('user:', user)
      localStorage.setItem('userId', user.uid)
      var db = firebase.firestore();

      var usrRef = db.collection('roles').doc(user.uid)
      .get()
      .then((doc)=>{
        var elemento = doc.data();
        console.log('elemento:', elemento.rol)
        if(elemento.rol === 'user'){
          console.log('no admin')
          firebase.auth().signOut()
          .then(()=>{
            that.mdbSpinningPreloader.stop()
            that.toast.error('Ese usuario no tiene permiso para entrar aquí');
          })

        } else {
          console.log('admin');
          
          that.mdbSpinningPreloader.stop()
          that.router.navigate(['main'])
        }
      })
	console.log(usrRef);
    })
    .catch(function(error) {
      // Handle Errors here.

      //var errorCode = error.code;
      var errorMessage = error.message;
      that.toast.error(errorMessage);
      // ...
    });
    //this.router.navigate(['main'])
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts